import { MediaMatcher } from '@angular/cdk/layout';
import { AsyncPipe } from '@angular/common';
import type { OnDestroy } from '@angular/core';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import type { Observable } from 'rxjs';

import { MainPanelComponent } from '@app/layout/main-panel/main-panel.component';
import { RightPanelComponent } from '@app/layout/right-panel/right-panel.component';
import { PanelService } from '@app/services';
import { Breakpoint } from '@app/types/breakpoint.enum';

@Component({
  selector: 'container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
  imports: [
    MatSidenavModule,
    MainPanelComponent,
    RightPanelComponent,
    AsyncPipe,
  ],
})
export class ContainerComponent implements OnDestroy {
  private readonly panelService = inject(PanelService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly media = inject(MediaMatcher);

  private readonly _mobileQueryListener: () => void;

  public rightPanelVisibility$: Observable<boolean> = this.panelService.rightPanelVisibility$;
  public mobileQuery: MediaQueryList;
  public isClosed: boolean;

  constructor() {
    this.mobileQuery = this.media.matchMedia(`(max-width: ${Breakpoint.medium})`);
    this._mobileQueryListener = (): void => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);

    this.isClosed = this.mobileQuery.matches;
  }

  public closeRightVisibility(): void {
    this.panelService.toggleRightPanelVisibility(false);
  }

  public ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
  }
}
